import { encryptData, decryptData } from '../utils/encryption';

const AUTH_DATA_KEY = 'authData';
const REMEMBER_ME_KEY = 'rememberMeData';
const ORG_DETAILS_KEY = 'organizationDetails';

export const authStorageService = {
  storeAuthData(authData) {
    try {
      const expirationHours = parseInt(import.meta.env.VITE_TOKEN_EXPIRATION_HOURS || '87600', 10);
      const expiresAt = new Date().getTime() + expirationHours * 60 * 60 * 1000;

      const dataToStore = {
        user: authData.user,
        accessToken: authData.accessToken,
        expiresAt: expiresAt
      };
      localStorage.setItem(AUTH_DATA_KEY, encryptData(dataToStore));
      return Promise.resolve(true);
    } catch {
      return Promise.resolve(false);
    }
  },

  async getAuthData() {
    try {
      const storedData = localStorage.getItem(AUTH_DATA_KEY);
      if (!storedData) return null;

      const decryptedData = decryptData(storedData);

      if (decryptedData?.expiresAt && new Date().getTime() > decryptedData.expiresAt) {
        await this.clearAuthData();
        return null;
      }
      return decryptedData;
    } catch {
      return null;
    }
  },

  clearAuthData() {
    localStorage.removeItem(AUTH_DATA_KEY);
    localStorage.removeItem(ORG_DETAILS_KEY);
    return Promise.resolve();
  },

  isAuthenticated() {
    return this.getAuthData().then(authData => !!(authData?.accessToken && authData?.user));
  },

  storeRememberMeData(email, password) {
    try {
      localStorage.setItem(REMEMBER_ME_KEY, encryptData({ email, password }));
      return Promise.resolve(true);
    } catch {
      return Promise.resolve(false);
    }
  },

  getRememberMeData() {
    try {
      const stored = localStorage.getItem(REMEMBER_ME_KEY);
      return stored ? Promise.resolve(decryptData(stored)) : Promise.resolve(null);
    } catch {
      return Promise.resolve(null);
    }
  },

  clearRememberMeData() {
    localStorage.removeItem(REMEMBER_ME_KEY);
    return Promise.resolve(true);
  },

  storeOrganizationDetails(details) {
    try {
        localStorage.setItem(ORG_DETAILS_KEY, encryptData(details));
        return Promise.resolve(true);
    } catch {
        return Promise.resolve(false);
    }
  },

  async getOrganizationDetails() {
    try {
        const stored = localStorage.getItem(ORG_DETAILS_KEY);
        return stored ? decryptData(stored) : null;
    } catch {
        return null;
    }
  }
};